<div #container
     class="container bg2 page-keyword2">

  <app-header [keyword]="keyword"
              [placeholder]="placeholder"
              [keyHistory]="HistoryKeySearch"
              canGoHistory="true"
              (goHistory)="onGoHistory()"
              (search)="onSearch($event)"></app-header>

  <app-left-menu></app-left-menu>

  <section class="video-list">

    <div class="inner wrap">

      <div class="list-wrap">

        <ul>
          <li *ngIf="(listVideo === null || listVideo.length === 0) && !IsLoading"
              class="empty-box">
            <div class="img-box">
              <img src="assets/img/img_menu_tiger.svg">
            </div>
            <div class="keyword-no-result-box">
              {{ emptyMsg }}
            </div>
          </li>
          <li class="reload-icon" *ngIf="IsLoading">
            <img #reload src="assets/img/loading_icon.gif">
          </li>
          <li *ngFor="let video of listVideo">
            <app-video-item [video]="video"
                            [sendingBookmark]="sendingBookmark"
                            (toggleBookmark)="ToggleBookmark($event)"></app-video-item>
          </li>

        </ul>


      </div>

    </div>
  </section>



  <app-footer [on]="GetFooterOn()"></app-footer>

</div>

<app-common-popups></app-common-popups>
